export const componentsContext = require.context(".", true, /\_controller.js$/);
